import SelectedPlanView from './SelectedPlan.View';
import { useBilling } from 'hooks';
import { SubscriptionPlan } from '@innovationdepartment/proxima-sdk-axios';

const SelectedPlan = ({ type }: { type: SubscriptionPlan }) => {
  const { loading, navigateToShopifyApprovalPage } = useBilling();

  const onSubmit = async () => {
    await navigateToShopifyApprovalPage(type);
  };

  return <SelectedPlanView onSubmit={onSubmit} loading={loading} type={type} />;
};

export default SelectedPlan;
